import { Box, Typography, useTheme } from '@mui/material';
import List from 'components/list/list';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import { ArrowRight, CircleAlert, TriangleAlert, X } from 'lucide-react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useScenarioFishGroupsState } from 'views/bluviu-nutrition/features/scenarios-v2/context/scenario-fish-groups-context';
import { ScenarioCageData } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-cage-data.type';

type FeedProgramReviewListProps = {
  cageData: ScenarioCageData[];
};

const FeedProgramReviewList: React.FC<FeedProgramReviewListProps> = ({ cageData }) => {
  const theme = useTheme();
  const intl = useIntl();
  const [hideBanner, setHideBanner] = React.useState(false);

  const { cageFeedPrograms } = useScenarioFishGroupsState();

  const columns = [
    {
      id: 'fishGroup',
      label: intl.formatMessage({ id: 'bluViuNutrition.applyFeed.reviewList.fishGroup' }),
    },
    {
      id: 'newFeedProgram',
      label: intl.formatMessage({ id: 'bluViuNutrition.applyFeed.reviewList.newFeedProgram' }),
    },
  ];


  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {!hideBanner && (
        <Box borderRadius={2} sx={{ background: theme.palette.orange.o25 }} display={'flex'} gap={2} alignItems={'center'}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1, minHeight: "90px" }}>
            <Box sx={{ flexShrink: 0, width: "14px" }} />
            <Box>
              <TriangleAlert size={24} color={theme.palette.orange.main} />
            </Box>
            <Box>
              <Typography fontSize={14} fontWeight={600} color={theme.palette.darkBlue.main}>Existing plan and/or Projection</Typography>
              <Typography fontSize={14} color={theme.palette.green.dark}>
                This site has an active plan and/or projection from a different scenario, and applying new ones will override it. Consider reviewing before you apply.
              </Typography>
            </Box>
          </Box>
        </Box>
      )}


      <Typography fontSize={16} fontWeight={500} color={theme.palette.gray.dark}>
        <FormattedMessage id="bluViuNutrition.applyFeed.reviewList.title" />
      </Typography>
      <List
        dark
        options={columns}
        sx={{
          ['.MuiTableCell-body']: {
            backgroundColor: theme.palette.lightBlue.o25,
          },
        }}
      >
        {cageData.map((cage) => {
          const overrideProgram = cageFeedPrograms.find((program) => program.fishGroupId === cage.fishGroupId);
          return (
            <ListRow key={cage.id}>
              <ListCell>{cage.fishGroupName}</ListCell>
              <ListCell>
                <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
                  <ArrowRight size={16} />
                  <Typography fontWeight={500}>{overrideProgram?.feedProgramName || 'New Feed'}</Typography>
                </Box>
              </ListCell>
            </ListRow>
          )
        })}
      </List>
    </Box>
  );
};

export default FeedProgramReviewList;
